import axios from 'axios';
import Forms from '../common/forms';

export default class ContactForm {
    constructor() {
        this.section = document.querySelector('.component-contact-form');
        this.form = document.querySelector('#contactForm');

        if (!this.section || !this.form) return;

        this.business = this.form.dataset.business;
        this.subjectField = this.form.querySelector('#cf_assunto_site');
        this.typeField = this.form.querySelector('#type');






        this.anchor = document.querySelector('body');
        this.successMessage = this.section.querySelector('.component-contact-form .success-form');
        this.errorMessage = this.section.querySelector('.component-contact-form .error-form');
        this.errorSubmitMessage = this.section.querySelector('.component-contact-form .error-submit-form');
        this.btnSubmit = this.form.querySelector('button');


        new Forms();

        this.initForm();

        this.ready();
        this.initRecaptcha();
    }

    ready() {
        this.form.setAttribute('novalidate', '');

        this.form.addEventListener('submit', (event) => {
            event.preventDefault();

            const fields = this.form.querySelectorAll('input, select, textarea');
            let isValid = true;

            fields.forEach((field) => {
                const formLine = field.closest('.form-line, .checkboxLine');
                const erroCampo = formLine && formLine.querySelector('.erro-campo');

                if (!field.checkValidity()) {
                    isValid = false;
                    field.classList.add(Forms.config().fieldClass);
                    if (erroCampo) erroCampo.classList.remove('hidden');
                } else {
                    field.classList.remove(Forms.config().fieldClass);
                    if (erroCampo) erroCampo.classList.add('hidden');
                }
            });

            if (!isValid) {
                this.errorMessage.classList.remove('hidden');
                Forms.activeErros(this.form);
                return;
            }

            this.errorMessage.classList.add('hidden');
            this.sendForm(this.form);
        });

        this.form.querySelectorAll('input, select, textarea').forEach((field) => {
            field.addEventListener('blur', () => {
                const formLine = field.closest('.form-line, .checkboxLine');
                const erroCampo = formLine && formLine.querySelector('.erro-campo');

                if (!field.checkValidity()) {
                    field.classList.add(Forms.config().fieldClass);
                    if (erroCampo) erroCampo.classList.remove('hidden');
                } else {
                    field.classList.remove(Forms.config().fieldClass);
                    if (erroCampo) erroCampo.classList.add('hidden');
                }
            });
        });
    }

    initRecaptcha() {
        this.form.querySelectorAll('input, select, textarea').forEach((field) => {
            field.addEventListener('focus', () => {
                if (!window.grecaptcha) {
                    window.loadRecaptchaV3();
                }
            });
        });
    }

    validateCNPJ(field) {
        field.addEventListener('blur', (e) => {
            if (!field.hasAttribute('required')) {
                e.target.setCustomValidity('');
                return;
            }

            const cnpj = e.target.value.replace(/\D/g, '');
            const isValidCnpj = (cnpj) => {
                if (!cnpj || cnpj.length !== 14) return false;
                if (/^(\d)\1+$/.test(cnpj)) return false;

                const calcCheckDigit = (cnpj, pos) => {
                    const weights =
                        pos === 12
                            ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
                            : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

                    let sum = 0;
                    for (let i = 0; i < weights.length; i++) {
                        sum += parseInt(cnpj.charAt(i)) * weights[i];
                    }

                    const rest = sum % 11;
                    return rest < 2 ? 0 : 11 - rest;
                };

                const digit1 = calcCheckDigit(cnpj, 12);
                const digit2 = calcCheckDigit(cnpj, 13);

                return digit1 === parseInt(cnpj.charAt(12)) && digit2 === parseInt(cnpj.charAt(13));
            };

            if (cnpj && !isValidCnpj(cnpj)) {
                e.target.setCustomValidity('CNPJ inválido');
                e.target.reportValidity();
            } else {
                e.target.setCustomValidity('');
            }
        });
    }

    initForm() {
        const cnpjField = this.form.querySelector('.lineCNPJ input');
        if (cnpjField) {
            this.validateCNPJ(cnpjField);
        }

        // Caso seja B2C e Consumidor Final, oculta os campos do formulário inteiro
        if (this.business === 'b2c' && this.typeField) {
            const hiddenLines = this.form.querySelectorAll('.hiddenLine');
            const lineButtons = this.form.querySelector('.lineButtons');

            this.typeField.addEventListener('change', () => {
                const isConsumer = this.typeField.value === 'Consumidor Final';

                hiddenLines.forEach((line) => {
                    line.classList.toggle('hidden', isConsumer);
                    line.classList.toggle('!hidden', isConsumer);
                });

                if (lineButtons) {
                    lineButtons.classList.toggle('hidden', !isConsumer);
                    lineButtons.classList.toggle('flex', isConsumer);
                }
            });
        }

        if (!this.subjectField) return;

        // Exibe ou oculta campos específicos com base na opção selecionada no campo de assunto
        this.subjectField.addEventListener('change', () => {
            const lines = ['lineCNPJ', 'lineStateCity', 'lineBuy'];
            const isSalesAndPurchaseOption = this.subjectField.value === 'Compra e venda de lubrificantes';
            const isLubricantSubject = ['Dúvidas sobre lubrificantes', 'Compra e venda de lubrificantes'].includes(this.subjectField.value);

            // Adiciona validação do CNPJ
            const cnpjField = this.form.querySelector('.lineCNPJ input');
            if (cnpjField) {
                cnpjField.setCustomValidity('');
            }

            // Exibe/oculta o campo Eu sou / Segmento
            const lineTypeSegmento = this.form.querySelector('.lineTypeSegmento');
            if (lineTypeSegmento) {
                lineTypeSegmento.classList.toggle('!hidden', !isLubricantSubject);
                const selectField = lineTypeSegmento.querySelector('select');
                if (selectField) {
                    if (isLubricantSubject) {
                        selectField.setAttribute('required', 'required');
                        selectField.setAttribute('aria-required', 'true');
                    } else {
                        selectField.removeAttribute('required');
                        selectField.removeAttribute('aria-required');
                        selectField.value = '';

                        // B2C: restaura hiddenLines caso "Consumidor Final" estivesse selecionado
                        if (this.business === 'b2c') {
                            this.form.querySelectorAll('.hiddenLine').forEach((line) => {
                                line.classList.remove('hidden', '!hidden');
                            });
                            const lineButtons = this.form.querySelector('.lineButtons');
                            if (lineButtons) {
                                lineButtons.classList.add('hidden');
                                lineButtons.classList.remove('flex');
                            }
                        }
                    }
                }
            }

            lines.forEach((lineClass) => {
                const lineElement = this.form.querySelector(`.${lineClass}`);
                if (lineElement) {
                    lineElement.classList.toggle('hidden', !isSalesAndPurchaseOption);

                    lineElement.querySelectorAll('input, select').forEach((input) => {
                        if (isSalesAndPurchaseOption) {
                            input.setAttribute('required', 'required');
                            input.setAttribute('aria-required', 'true');
                        } else {
                            input.removeAttribute('required');
                            input.removeAttribute('aria-required');
                        }
                    });
                }
            });
        });
    }

    sendForm(form) {
        reloadCaptcha('contact', 'g-recaptcha-response', () => {
            this.errorSubmitMessage.classList.add('hidden');
            this.successMessage.classList.add('hidden');
            this.errorMessage.classList.add('hidden');

            this.btnSubmit.disabled = true;
            this.btnSubmit.classList.add('loading');

            const dataForm = new FormData(form);

            const acceptedElement = this.form.querySelector('#accepted');
            dataForm.set('accepted', acceptedElement && acceptedElement.checked ? 1 : 0);

            const urlForm = base_url + (this.business === 'b2b' ? 'storeB2b' : 'storeB2c');

            axios({
                method: 'POST',
                url: urlForm,
                data: dataForm,
                headers: { 'Content-Type': 'multipart/form-data' },
            })
                .then(() => {
                    form.reset();
                    this.errorSubmitMessage.classList.add('hidden');
                    Forms.showSuccess(form, this.successMessage, this.errorMessage);
                    Forms.setLoading(this.btnSubmit, false);

                    setTimeout(() => {
                        this.successMessage.classList.add('hidden');
                    }, 5000);
                })
                .catch(() => {
                    console.error('Erro ao enviar o formulário');

                    this.errorMessage.classList.add('hidden');
                    Forms.showError(this.errorSubmitMessage, this.successMessage);
                    Forms.setLoading(this.btnSubmit, false);
                });
        });
    }
}

const initContactForm = () => {
    if (document.querySelector('.component-contact-form')) {
        try {
            new ContactForm();
        } catch (error) {
            console.error('[ContactForm] init error:', error);
        }
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactForm);
} else {
    initContactForm();
}
